import { notifyStatusChange } from "../../helpers/common";
import { WORKER_MESSAGE_BOOK_GENERATED_SUCCESSFULLY } from "../../protocol/messages";
import { GenerateBookHandlerParams, Task } from "../../types";
import { generateBookUrl } from "./generate-book";

export const generateBookHandler = async (
  task: Task<GenerateBookHandlerParams>
): Promise<void> => {
  await notifyStatusChange(task, "executing");

  const { bookData, bookCacheStoreSnapshot } = task.parameters;
  const { book, theme } = bookData;

  try {
    const url = await generateBookUrl(book, theme, bookCacheStoreSnapshot, task);
    await notifyStatusChange(
      task,
      "completed",
      WORKER_MESSAGE_BOOK_GENERATED_SUCCESSFULLY,
      {
        url,
      }
    );
  } catch (e: any) {
    console.log("Error on task queue", e);
    notifyStatusChange(task, "error", e.message);
  }
};
